// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#send-other-user-safety-confirm[data-v-3998bcdb]{max-width:820px;margin-left:auto;margin-right:auto}#send-other-user-safety-confirm .cancel-btn[data-v-3998bcdb],#send-other-user-safety-confirm .register-btn[data-v-3998bcdb]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
